/**
 * Language Selector Component
 * 
 * Dropdown to switch between NL and EN languages.
 * Uses the LanguageContext for state management.
 */

import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { Globe, Check } from 'lucide-react';

const LanguageSelector = ({ variant = 'default', showLabel = true }) => {
  const { language, setLanguage, currentLanguage, languages, t } = useLanguage();
  const { token } = useAuth();

  const handleLanguageChange = (langCode) => {
    setLanguage(langCode, token);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === 'ghost' ? 'ghost' : 'outline'} 
          size={showLabel ? 'default' : 'icon'}
          className={variant === 'sidebar' ? 'w-full justify-start gap-2' : ''}
          data-testid="language-selector"
        >
          <span className="text-lg">{currentLanguage.flag}</span>
          {showLabel && (
            <span className="hidden sm:inline">{currentLanguage.name}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className="flex items-center justify-between cursor-pointer"
            data-testid={`language-option-${lang.code}`}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.name}</span>
            </div>
            {language === lang.code && (
              <Check className="w-4 h-4 text-green-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
